module.exports = __webpack_public_path__ + "assets/img/title-286f5a8e.png";